import React, { Fragment } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody } from "reactstrap";
import Fullscreen from "Components/Fullscreen";
import ReactPlayer from "react-player";

/**
 * ReactPlayer v3+ uses `src` (not `url`) and only supports a fixed set of hosts
 * (YouTube, Vimeo, Wistia, file URLs, HLS, Mux, Spotify, Twitch, TikTok, etc.).
 * SoundCloud / Facebook / Dailymotion are not supported in v3.
 */
function player() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.player" />}
            />
            <div className="float-right">
              <Fullscreen />
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* YouTube */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <ReactPlayer
                      src="https://www.youtube.com/watch?v=LXb3EKWsInQ"
                      width="100%"
                      controls
                      playsInline
                    />
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>

        {/* Vimeo */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <ReactPlayer
                      src="https://vimeo.com/90509568"
                      width="100%"
                      controls
                      playsInline
                    />
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>

        {/* Wistia (embed URL shape required by react-player v3) */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <ReactPlayer
                      src="https://wistia.com/medias/e4a27b971d"
                      width="100%"
                      controls
                      playsInline
                    />
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>

        {/* Direct file (HTML5 video) */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <ReactPlayer
                      src="https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                      width="100%"
                      controls
                      playsInline
                    />
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>

        {/* Spotify (audio) */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <ReactPlayer
                      src="https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC"
                      width="100%"
                      controls
                      playsInline
                    />
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
      </Fragment>
    );
}

export default player;
